'use client'
import React from 'react'
import { useForm, Controller } from "react-hook-form";
import FormInput from 'components/common/FormInput';
import { RiseLoader } from 'react-spinners';

const SigninForm = ({ handleLogin , loader}) => {

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <form onSubmit={handleSubmit(handleLogin)}>
      <div className="grid grid-cols-1 gap-5">
        <div className="col-span-1">
          <Controller
            name="name_email"
            control={control}
            rules={{
              required: "Name is required",
            //   pattern: {
            //     value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
            //     message: "Invalid email address",
            //   },
            }} // Email validation rule
            render={({ field }) => (
              <FormInput
                {...field}
                placeholder="Enter Name"
                error={errors.name_email?.message}
              />
            )}
          />
        </div>
        <div className="col-span-1">
          <Controller
            name="password"
            control={control}
            rules={{
              required: "Password is required",
            //   minLength: {
            //     value: 6,
            //     message: "Password must be at least 6 characters",
            //   },
            }} 
            render={({ field }) => (
              <FormInput
                {...field}
                type="password"
                placeholder="Enter password"
                error={errors.password?.message}
              />
            )}
          />
        </div>
        <div className="col-span-1 flex items-center justify-center">
          <button variant="primary" type="submit" className='bg-blue-500 text-white py-4 text-[16px] font-semibold rounded-full md:w-[240px] xs:w-[160px] sm:w-[210px]'>
            {loader ?  <RiseLoader color="#ffffff" size={14} /> : "Submit"}
          </button>
        </div>
      </div>
    </form>
  );
}

export default SigninForm;
